import React, {
    FunctionComponent as FC,
    useRef,
    useEffect,
    useState,
} from "react";

import { useNavigate, Link } from 'react-router-dom';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../../state';
import { State } from '../../../../../state/reducers';
import { Button, Row, Col, Form, Input, Checkbox, Layout, Typography, message } from "antd";
const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

type RegisterFields = {
    username: string;
    password: string;
    confirm: string;
    email: string;
};

interface RegisterProps {

}

const Register: FC<RegisterProps> = (props) => {
    const {
    } = props

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const {
        performRegister,
    } = bindActionCreators(actionCreators, dispatch)

    const registerStatus: boolean = useSelector((state: State) => state.uiReducer?.registerState.registerStatus) as boolean;
    const errStatus: string = useSelector((state: State) => state.uiReducer?.registerState.error) as string;

    useEffect(() => {
        if (registerStatus) {
            navigate('/login');
            message.success('Register Successful!');
        }

    }, [registerStatus]);

    // Function to handle form submission
    const onFinish = (values: RegisterFields) => {
        if (values.password !== values.confirm) {
            message.error('The two passwords that you entered do not match!');
        } else {
            const register_values = {
                username: values.username,
                password: values.password,
                email: values.email,
            };
            performRegister(register_values);
        }

    };

    // Function to handle submission failure
    const onFinishFailed = (errorInfo: any) => {
        console.log('Register failed:', errorInfo);
        message.error('Submission failed, please check your input.');
    };

    return (
        <Layout className="register-layout">
            <Header style={{ backgroundColor: 'transparent', boxShadow: "none" }}>
                <Row justify="space-between" style={{ width: '100%' }}>
                    <Col xs={8} sm={8} md={8} lg={8}>
                        <div className='header-left-div'>
                            <div className='logo'>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Header>
            <Content className="register-content">
                <div className="register-wrapper">
                    <div className="branding-section">
                        <div className="branding-container">
                            <div className="branding-text">Funding the Frontier</div>
                            <div className="branding-tagline">Visualizing the Broad Impact of Science and Science Funding</div>
                        </div>
                        <div className='branding-copyright'>
                            Copyright © 2022-2024 CSSI
                        </div>
                    </div>
                    <div className="content-wrapper">
                        <div className="register-form">
                            {/* <div className="register-text">Log in</div> */}
                            <Form
                                name="register"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                initialValues={{ remember: false }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="on"
                            >
                                <Form.Item
                                    className="username-box"
                                    name="username"
                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                >
                                    <Input
                                        prefix={<UserOutlined
                                            className="site-form-item-icon" />}
                                        placeholder="User Name"
                                        style={{ borderRadius: '16px', border: 'none', boxShadow: 'none', color: '#1a1a1a' }} />
                                </Form.Item>
                                <Form.Item
                                    className="password-box"
                                    name="password"
                                    rules={[{ required: true, message: 'Please input your password!' }]}
                                >
                                    <Input
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        placeholder="Password"
                                        style={{ borderRadius: '16px', border: 'none', boxShadow: 'none', color: '#1a1a1a' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    className="confirm-box"
                                    name="confirm"
                                    hasFeedback
                                    rules={[
                                        { required: true, message: 'Please confirm your password!' },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Passwords that you entered do not match!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        placeholder="Confirm Password"
                                        style={{ borderRadius: '16px', border: 'none', boxShadow: 'none', color: '#1a1a1a' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    className="email-box"
                                    name="email"
                                    rules={[{ required: true, message: 'Please input your email!' }]}
                                >
                                    <Input
                                        prefix={<UserOutlined className="site-form-item-icon" />}
                                        placeholder="Email"
                                        style={{ borderRadius: '16px', border: 'none', boxShadow: 'none', color: '#1a1a1a' }}
                                    />
                                </Form.Item>
                                <div className="login-link">
                                    <Link to="/login">Back to Login</Link>
                                </div>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="register-form-button">
                                        Register
                                    </Button>
                                </Form.Item>
                                <div className="register-form-footer">
                                    {/*<Link to="/register" className="link">Register</Link>*/}
                                    {/*<Link to="/delete-account" className="link">Delete Account</Link>*/}
                                </div>
                            </Form>


                        </div>
                    </div>
                </div>
            </Content>
            {/* <Footer className="register-footer">
            <Text>Copyright © 2022-2024 CSSI</Text>
          </Footer> */}
        </Layout>
    );
}

export default Register;